import PropTypes from "prop-types";

import { t } from "../../../services";
import { strCode } from "../../../consts";

import { Heading6, Modal } from "../../../components";
import MarketsModalForm from "./MarketsModalForm";

const MarketsModal = ({ data, isActive, onFormSave, onFormClose, onRemoveMarket }) => {
  const modalHeader = <Heading6>{data ? data.name : t(strCode.ADD_MARKET_TITLE)}</Heading6>;

  return (
    <Modal
      id="markets-modal"
      active={isActive}
      preventOverflow
      setActive={onFormClose}
      modalHeader={modalHeader}
      closable={false}>
      <MarketsModalForm
        data={data}
        onFormClose={onFormClose}
        onFormSave={onFormSave}
        onRemoveMarket={onRemoveMarket}
      />
    </Modal>
  );
};

MarketsModal.propTypes = {
  data: PropTypes.shape({
    country: PropTypes.string,
    market: PropTypes.string,
    name: PropTypes.string
  }),
  isActive: PropTypes.bool.isRequired,
  onFormSave: PropTypes.func.isRequired,
  onFormClose: PropTypes.func.isRequired,
  onRemoveMarket: PropTypes.func.isRequired
};

export default MarketsModal;
